@if (hasUnits) {
  <mat-button-toggle-group [formControl]="control" class="grid grid-cols-3">
    @for (unit of units(); track unit) {
      <mat-button-toggle [value]="unit">
        {{ unit | absenceUnit }}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
} @else {
  <p class="h-14 px-4">No existen unidades disponibles</p>
}
